import { styled } from '@mui/system';
import {Stack as StackMUI, TextField as TextFieldMUI} from '@mui/material';
import { theme } from 'oems/theme';

export const Stack = styled(StackMUI)`
  border:1px solid ${({ theme }) => theme.palette.text.main};
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 10px;
`;

export const TextField = styled(TextFieldMUI)`
    background-color: ${({ theme }) => theme.palette.background.paper};
    margin-bottom: 10px;
`;

export const Label = styled('div')`
    font-weight: 400;
    font-size: 14px;
    line-height: 150%;
    color: ${theme.palette.secondary.main};
`;

export const Buttons = styled('div')`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 24px;
  flex-wrap: wrap;
  margin-top: 24px;
`;

export const Box = styled('div')`
  background: #ffffff;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.17);
  border-radius: 12px;
  padding: 24px;
  height: 100%;
  overflow: auto;
`;

export const LayoutWrapper = styled('div')`
  .react-grid-layout {
    position: relative;
    background: ${theme.palette.background.paper};
  }

  &.isEditing {
    border: 1px dashed ${theme.palette.border.light};

    .item {
      border: 1px dashed ${theme.palette.border.light};

      .deleteButton {
        position: absolute;
        top: 5px;
        right: 0;
        background: #ffffff50;
      }

      .react-resizable-handle-se {
        width: 10px;
        height: 10px;
        display: block;
        position: absolute;
        bottom: 6px;
        right: 6px;
        border-right: 2px solid black;
        border-bottom: 2px solid black;
      }
    }
  }
`;
